import { trackEvent } from './analytics';

export const POLYVOX_ORIGIN = 'https://usepolyvox.com';

// Set once the visitor clicks through to Polyvox from anywhere on the site.
// After that the pop-up stops appearing; until then it shows every time.
const VISITED_KEY = 'polyvox.visited';

export function polyvoxUrl(placement) {
  const url = new URL(POLYVOX_ORIGIN);
  url.searchParams.set('utm_source', 'langshazam');
  url.searchParams.set('utm_medium', placement.startsWith('email') ? 'email' : 'web');
  url.searchParams.set('utm_campaign', 'langshazam_funnel');
  url.searchParams.set('utm_content', placement);
  return url.toString();
}

export function hasVisitedPolyvox() {
  try {
    return localStorage.getItem(VISITED_KEY) === '1';
  } catch {
    return false;
  }
}

export function trackPolyvoxClick(placement, extra) {
  try {
    localStorage.setItem(VISITED_KEY, '1');
  } catch {
    // Storage blocked (private mode) — the pop-up just keeps showing.
  }
  trackEvent('polyvox_click', { placement, ...(extra || {}) });
}
